import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

const Breadcrumb = ({ propertyId, scenarioId, groupId }) => {
  const [property, setProperty] = useState(null);
  const [scenario, setScenario] = useState(null);
  const [group, setGroup] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (propertyId) {
        const propertyDoc = await getDoc(doc(db, 'properties', propertyId));
        if (propertyDoc.exists()) {
          setProperty({ id: propertyId, ...propertyDoc.data() });
        }
      }

      if (scenarioId) {
        const scenarioDoc = await getDoc(doc(db, 'scenarios', scenarioId));
        if (scenarioDoc.exists()) {
          setScenario({ id: scenarioId, ...scenarioDoc.data() });
        }
      }

      if (groupId) {
        const groupDoc = await getDoc(doc(db, 'investmentGroups', groupId));
        if (groupDoc.exists()) {
          setGroup({ id: groupId, ...groupDoc.data() });
        }
      }
    };

    fetchData();
  }, [propertyId, scenarioId, groupId]);

  // Investment Groups breadcrumb
  if (groupId) {
    return (
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/investment-groups" className="text-primary text-decoration-none">
              Investment Groups
            </Link>
          </li>
          {group && (
            <li className="breadcrumb-item active text-light" aria-current="page">
              {group.name}
            </li>
          )}
        </ol>
      </nav>
    );
  }

  // Properties breadcrumb
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item">
          <Link to="/" className="text-primary text-decoration-none">Properties</Link>
        </li>
        
        {property && (
          <li className="breadcrumb-item">
            {scenarioId ? (
              <Link to={`/property/${property.id}`} className="text-primary text-decoration-none">
                {property.address.street}
              </Link>
            ) : (
              <span className="text-light">{property.address.street}</span>
            )}
          </li>
        )}

        {scenario && (
          <li className="breadcrumb-item active text-light" aria-current="page">
            {scenario.name}
          </li>
        )}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
